export default function initScrollLinks() {
  const scrollLinks = document.querySelectorAll('.scroll-link');
  if (!scrollLinks.length) return;

  scrollLinks.forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const target = document.querySelector(link.getAttribute('href'));
      target.scrollIntoView({ behavior: 'smooth' });
    });
  });
}
